import { useInfiniteQuery } from '@tanstack/react-query'
import { learnerStatusApi } from '@/api/learnerStatus'

export function useAdminLearnerAttendanceHistory(userId: number, enabled: boolean) {
  return useInfiniteQuery({
    queryKey: ['lc', 'admin', 'learner', userId, 'attendance', 'history'],
    queryFn: async ({ pageParam }) => {
      const res = await learnerStatusApi.getAttendanceHistory(userId, { cursor: pageParam, limit: 30 })
      return res.data.data
    },
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.nextCursor,
    enabled,
    staleTime: 30_000,
  })
}
